<template>
    <div class="table-container" aria-describedby="keys-table">
        <v-table>
            <thead>
                <tr>
                    <template v-for='(value, key) in apiResponseObject[0]' :key='key'>
                        <th v-if="key !== 'id' && key !== 'improved_billing' && key !== 'permissions' && apiResponseObject && apiResponseObject.length > 0">
                            {{ getColumnHeader(key) }}
                            <span v-if="shouldShowSortButton(key)" class="sort-button" @click="toggleSort(key)">
                                <v-icon :icon="getSortIcon(key)"></v-icon>
                            </span>
                        </th>
                    </template>
                    <th></th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(item, index) in apiResponseObject" :key="index">
                    <template  v-for="(value, key) in item" :key="key">
                        <td class="key-item" v-if="key !== 'id' && key !== 'improved_billing' && key !== 'permissions'">
                        <template v-if="key !== 'id' && key !== 'improved_billing' && key !== 'permissions'">
                            <span v-if="key=== 'value'" class="show-link" @click='copyToClipboard(item)'>
                            •••• <v-icon :icon="copiedStatus[item.id] ? 'fas fa-check' : 'fas fa-clipboard'" :title="copiedStatus[item.id] ? 'Copied!' : 'Copy to clipboard'"></v-icon>
                            </span>
                            <span v-else :style="key === 'bundle_id' ? 'font-family: monospace;' : ''">
                                {{ getFormattedValue(key, value) }}
                            </span>
                        </template>
                        </td>
                    </template>

                    <td>
                        <span class='delete-button' @click='confirmDelete(item.id)'>
                            <img src="@/assets/images/icons/x-color.svg" alt="Delete" class="delete-icon-svg" />
                        </span>
                    </td>
                </tr>
            </tbody>
        </v-table>
    </div>
</template>

  <script>
  import { computed, reactive } from 'vue';
  import { useStore } from 'vuex';


  export default {
    name: 'KeysTable',
    emits: ['key-copied'],
    setup(props, { emit }) {
        const store = useStore();
        const copiedStatus = reactive({});

        const apiResponseObject = computed(() => store.state.apiResponseObject || []);

        const copyToClipboard = async (item) => {
            if (!item || !item.value) return;
            try {
                await navigator.clipboard.writeText(item.value);
                copiedStatus[item.id] = true;
                emit('key-copied', 'Copied to clipboard!');
                setTimeout(() => {
                    copiedStatus[item.id] = false;
                }, 2000);
            } catch (err) {
                emit('key-copied', 'Failed to copy!');
            }
        };

        const getColumnHeader = (key) => {
            const columnHeaders = {
                created_on: 'Created On',
                last_used: 'Last Used',
                bundle_id: 'Bundle ID',
				value: 'Value'
            };
            return columnHeaders[key] || key;
        };

        const formattedDateTime = (dateTimeString) => {
            if (!dateTimeString) {
                return '-';
            }
            const options = {
                year: 'numeric',
                month: 'numeric',
                day: 'numeric',
                // hour: 'numeric',
                // minute: 'numeric',
                // hour12: true,
            };
            const date = new Date(dateTimeString);
            return date.toLocaleString('en-US', options);
        };

        const getFormattedValue = (key, value) => {
            if (key === 'created_on' || key === 'last_used') {
                return formattedDateTime(value);
            }
            return value;
        };

        const confirmDelete = (itemData) => {
            store.commit('SET_DELETE_ITEM_DATA', itemData);
            store.commit('SET_SHOW_DELETE_CONFIRMATION_MODAL', true);
        }


        const shouldShowSortButton = (key) => {
            return ['created_on', 'last_used', 'name', 'bundle_id'].includes(key);
        };

        const toggleSort = (key) => {
            store.commit('TOGGLE_SORT', key);
        };

        const getSortIcon = (key) => {
            let sortDirection = store.state.sortDirection === 'asc' ? 'fas fa-sort-up' : 'fas fa-sort-down';
            return store.state.currentSortColumn === key ? sortDirection : 'fas fa-sort';
        };


      return {
        apiResponseObject,
        copyToClipboard,
        copiedStatus,
        getColumnHeader,
        getFormattedValue,
        confirmDelete,
        shouldShowSortButton,
        toggleSort,
        getSortIcon,
      };
    },
  };
  </script>

<style scoped lang="scss">
	@import "@/assets/styles/KeysTable.scss"
</style>
